import { render, staticRenderFns } from "./validated-text-input.vue?vue&type=template&id=45120bd8"
import script from "./validated-text-input.vue?vue&type=script&lang=js"
export * from "./validated-text-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports